import { render, staticRenderFns } from "./konfigurasi.vue?vue&type=template&id=fd981bc8&scoped=true&"
import script from "./konfigurasi.vue?vue&type=script&lang=js&"
export * from "./konfigurasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd981bc8",
  null
  
)

export default component.exports